<script>

    import { createEventDispatcher } from 'svelte'
    import { toast } from 'bulma-toast'
    import { MerchandisesStore, MerchandiseStore } from '../stores'

    import MerchandisesService from '../$services/merchandises.service'

    import SatProducts from '../catalogs/sat.products.svelte'
    import SatUnits from '../catalogs/sat.units.svelte'

    import InputNumber from '../$components/input.number.svelte'
    import InputText from '../$components/input.text.svelte'
    import Form from '../$components/form.svelte'

    const dispatch = createEventDispatcher()

    let loading = false
    let data = {
        alias: $MerchandiseStore.alias,
        productCode: $MerchandiseStore.productCode,
        productName: $MerchandiseStore.productName,
        productWarning: $MerchandiseStore.productWarning,
        unitCode: $MerchandiseStore.unitCode,
        unitName: $MerchandiseStore.unitName,
        items: $MerchandiseStore.items,
        value: $MerchandiseStore.value,
        weight: $MerchandiseStore.weight,
        description: $MerchandiseStore.description,
    }
   
    async function updateMerchandise() {
    
        loading = true
        const resp = await MerchandisesService.updateMerchandise($MerchandiseStore._id, data)
        loading = false
    
        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})
    
        MerchandisesStore.replace(resp.data)
        MerchandiseStore.set(resp.data)

        toast({message: 'Mercancia actualizada', type: 'is-success'})
        dispatch('updated', resp.data)
    }

</script>

<Form on:submit={updateMerchandise} on:canceled {loading} >
    <div class="columns">
        <div class="column">
            <InputText bind:value={data.alias} label="Alias" icon="star" placeholder="Alias de la mercancia" />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <SatProducts bind:productCode={data.productCode} bind:productName={data.productName} bind:productWarning={data.productWarning} />
        </div>
    </div>
    <div class="columns">
        <div class="column">
            <SatUnits bind:unitCode={data.unitCode} bind:unitName={data.unitName} />
        </div>
    </div>
    <div class="columns">
        <div class="column is-4">
            <InputNumber bind:value={data.items} label="Cantidad" icon="list-ol" placeholder="Cantidad de piezas" />
        </div>
        <div class="column">
            <InputNumber bind:value={data.value} label="Valor" icon="dollar-sign" placeholder="Valor en factura" />
        </div>
    </div>
    <div class="columns">
        <div class="column is-4">
            <InputNumber bind:value={data.weight} label="Peso" icon="weight" placeholder="Peso neto de la mercancia" />
        </div>
        <div class="column">
            <InputText bind:value={data.description} label="Descripción" icon="sticky-note" placeholder="Detalles de la mercancia" />
        </div>
    </div>
</Form>